import type { TargetareUniversRand } from "@/types/targetare";
import { FILTRE_RAPIDE_FIRME } from "@/utils/targetareFiltreRapide";
import { raportImplicit, type DefinitieRaport } from "@/utils/targetareRaport";
import { COLOANE_TABEL } from "@/utils/targetareTabel";

const COLOANE_INCADRARE = [
  "cui",
  "denumire",
  "dimensiune_stricta",
  "tier",
  "clasificare_estimata",
  "scor",
  "servicii_selectate",
  "servicii_scor",
  "sectoare",
  "servicii_principal",
  "servicii_secundar",
  "servicii_liste",
  "judet",
  "salariati",
];

const COLOANE_RISC = [
  "cui",
  "denumire",
  "dimensiune_stricta",
  "sectoare",
  "scor_risc",
  "nivel_risc",
  "risc_detalii",
  "clasificare_estimata",
  "tier",
  "judet",
  "salariati",
];

export const definitieRaportIncadrare: DefinitieRaport<TargetareUniversRand> = {
  cheie: "targetare.rapoarte.incadrare",
  coloane: COLOANE_TABEL,
  rapoarteImplicite: [
    raportImplicit("Încadrarea firmelor", COLOANE_INCADRARE, {
      sortare: [{ id: "scor", desc: true }],
    }),
    raportImplicit("Esențiale estimate", COLOANE_INCADRARE, {
      filtre: [
        {
          id: "f-es",
          coloana: "clasificare_estimata",
          operator: "egal",
          valoare: "ESSENTIAL",
          activ: true,
        },
      ],
      sortare: [{ id: "salariati", desc: true }],
    }),
    raportImplicit("Doar potriviri sub prag (tier D)", COLOANE_INCADRARE, {
      filtre: [
        {
          id: "f-d",
          coloana: "tier",
          operator: "egal",
          valoare: "D",
          activ: true,
        },
      ],
      sortare: [{ id: "scor", desc: true }],
    }),
  ],
  cheieRand: (r) => r.cui,
  filtreRapide: FILTRE_RAPIDE_FIRME,
  numeFisier: "incadrare",
  mesajGol: "Nicio firmă nu corespunde filtrelor.",
};

export const definitieRaportRisc: DefinitieRaport<TargetareUniversRand> = {
  cheie: "targetare.rapoarte.risc",
  coloane: COLOANE_TABEL,
  rapoarteImplicite: [
    raportImplicit("Nivelul de risc estimat", COLOANE_RISC, {
      sortare: [{ id: "scor_risc", desc: true }],
    }),
    raportImplicit("Risc esențial", COLOANE_RISC, {
      filtre: [
        {
          id: "f-re",
          coloana: "nivel_risc",
          operator: "egal",
          valoare: "esential",
          activ: true,
        },
      ],
      sortare: [{ id: "scor_risc", desc: true }],
    }),
    raportImplicit("Mai multe sectoare", COLOANE_RISC, {
      filtre: [
        {
          id: "f-ms",
          coloana: "risc_detalii",
          operator: "contine",
          valoare: ";",
          activ: true,
        },
      ],
      sortare: [{ id: "scor_risc", desc: true }],
    }),
  ],
  cheieRand: (r) => r.cui,
  filtreRapide: FILTRE_RAPIDE_FIRME,
  numeFisier: "nivel-risc",
  mesajGol: "Nicio firmă nu corespunde filtrelor.",
};
